// src/components/IntroPopup.jsx
import React from "react";
import Form from "./Form";

export default function IntroPopup({ show, onClose }) {
  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex={-1}
      style={{ background: "rgba(0,0,0,0.6)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-dark border-0 p-4">
          <div className="modal-header border-0">
            <h5 className="modal-title text-white">Enquire Now</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onClose}
            ></button>
          </div>

          <div className="modal-body">
            <Form type="popup" onSuccess={onClose} />
          </div>
        </div>
      </div>
    </div>
  );
}
